import { render, staticRenderFns } from "./Paystub.vue?vue&type=template&id=47a41c90&"
import script from "./Paystub.vue?vue&type=script&lang=js&"
export * from "./Paystub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports